<form class="container-fluid" [formGroup]="UserFormGroup">
  <!-- Page head: title left, secondary actions right (matches other
       flows like Sites and My Vendor). -->
  <div class="row align-items-center mb-2">
    <div class="col d-flex justify-content-between align-items-center">
      <h2 class="mb-0">
        @if (User) {
          {{ displayUserName(User) }}
        } @else {
          Add a user
        }
      </h2>
      <div class="action-row">
        <!-- VPDW-3826: vendor users no longer get a "Log in as" button — the
             legacy vendor impersonation flow is defunct. Client users keep it. -->
        @if (showImpersonateButton() && User && User.CompanyId) {
          <button type="button" class="btn btn-outline" (click)="logInAsUser()">
            Log in as
          </button>
        }
        @if (
          CompanyId &&
          LoggedInUser.UserAccountRole?.role !==
            'CLIENT_VENDOR_AND_SITES_MANAGER'
        ) {
          <button type="button" class="btn btn-outline" (click)="assignSites()">
            Assign sites
          </button>
        }
        @if (
          LoggedInUserType !== 'Vendor' &&
          LoggedInUser.UserAccountRole?.role !==
            'CLIENT_VENDOR_AND_SITES_MANAGER'
        ) {
          <button type="button" class="btn btn-ghost" (click)="resetForm()">
            Reset form
          </button>
        }
      </div>
    </div>
  </div>

  <div class="row row-padding">
    <div class="col">
      <app-display-card>
        <div class="inner-panel">
          <div class="row row-padding">
            <div class="col-md-3">
              <div class="row">
                <div class="col">
                  <label class="form-label"
                    >First Name<span class="required-field-asterisk"
                      >*</span
                    ></label
                  >
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <input
                    type="text"
                    class="form-control"
                    formControlName="firstName"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="row">
                <div class="col">
                  <label class="form-label"
                    >Last Name<span class="required-field-asterisk"
                      >*</span
                    ></label
                  >
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <input
                    type="text"
                    class="form-control"
                    formControlName="lastName"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="row">
                <div class="col">
                  <label class="form-label"
                    >Email<span class="required-field-asterisk">*</span></label
                  >
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <input
                    type="text"
                    class="form-control"
                    [pattern]="emailRegex.source"
                    formControlName="email"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="row">
                <div class="col">
                  <label class="form-label">Job Title</label>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <input
                    type="text"
                    class="form-control"
                    formControlName="jobTitle"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row row-padding">
            @if (
              LoggedInUser.UserAccountRole?.role !==
              'CLIENT_VENDOR_AND_SITES_MANAGER'
            ) {
              <div class="col-md-3">
                <div class="row">
                  <div class="col">
                    <label class="form-label"
                      >Permission Group<span class="required-field-asterisk"
                        >*</span
                      ></label
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <select
                      class="form-select"
                      (ngModelChange)="permissionGroupChanged()"
                      formControlName="UserAccountRoleId"
                    >
                      <option disabled selected [ngValue]="undefined">
                        Pick one...
                      </option>
                      @for (
                        AccountRole of UserAccountRoles;
                        track AccountRole
                      ) {
                        <option [ngValue]="AccountRole.id">
                          {{ getUserAccountTypeLabel(AccountRole.role!) }}
                        </option>
                      }
                    </select>
                  </div>
                </div>
              </div>
            }

            @if (showClientDropDown) {
              <div class="col-md-3">
                <div class="row">
                  <div class="col">
                    <label class="form-label" requiredAsterisk>Client</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <select class="form-select" formControlName="CompanyId">
                      <option disabled selected [ngValue]="null">
                        Pick one...
                      </option>
                      @for (company of Companies; track company) {
                        <option [ngValue]="company.id">
                          {{ company.legalName }}
                        </option>
                      }
                    </select>
                  </div>
                </div>
              </div>
            }

            <div class="col-md-3">
              <div class="row">
                <div class="col">
                  <label class="form-label">Phone</label>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="(___) ___-____"
                    [inputMask]="phoneMask"
                    formControlName="phone"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <div class="row">
                <div class="col">
                  <label class="form-label">Extension</label>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <input
                    type="text"
                    class="form-control"
                    [inputMask]="phoneExtensionMask"
                    formControlName="extension"
                  />
                </div>
              </div>
            </div>

            @if (LoggedInUserType !== 'Client') {
              <div class="col-md-3 d-flex flex-column justify-content-end">
                <div class="row">
                  <div class="col">
                    <div class="check-group">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        formControlName="allowTexts"
                      />
                      <label class="form-check-label"
                        >Allow VIVE to text me</label
                      >
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label class="text-notice"
                      >(Standard Text Message Rates May Apply)</label
                    >
                  </div>
                </div>
              </div>
            }
          </div>

          @if (
            LoggedInUserType === 'Client' ||
            (LoggedInUserType === 'Admin' && showClientDropDown)
          ) {
            <div class="row">
              <div class="col-auto">
                <div class="check-group">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    formControlName="sendWeeklyStatusUpdates"
                  />
                  <label class="form-check-label"
                    >Send Weekly Status Update Emails?</label
                  >
                </div>
              </div>
              <div class="col-auto">
                <div class="check-group">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    formControlName="sendDailyStatusUpdates"
                  />
                  <label class="form-check-label"
                    >Send Daily Status Update Emails?</label
                  >
                </div>
              </div>
            </div>
          }

          <div class="row row-padding">
            @if (ContactTypeOptions.length > 0) {
              <div class="col-md-3">
                <div class="row">
                  <div class="col">
                    <label class="form-label"
                      >Contact Type<span class="required-field-asterisk"
                        >*</span
                      ></label
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <!--Custom Tag Field Component Below-->
                    <div class="dropdown">
                      <div
                        id="contact-type-dropdown"
                        class="form-control tag-field dropdown-toggle-override"
                        (click)="
                          toggleContactTypeDropdown(); $event.stopPropagation()
                        "
                        [class.show]="contactTypeDropdownOpen"
                        role="button"
                        tabindex="0"
                      >
                        <span class="icon-container"
                          ><i
                            class="bi bi-chevron-down chevron-icon pull-right"
                          ></i
                        ></span>
                        @if (!isBidBillingComplianceContact()) {
                          <span
                            class="badge bg-primary badge-margin"
                            contenteditable="false"
                          >
                            Additional Contact
                          </span>
                        }
                        @for (
                          SelectedContactType of SelectedContactTypeOptions;
                          track SelectedContactType
                        ) {
                          <span
                            class="badge bg-primary badge-margin"
                            contenteditable="false"
                          >
                            {{ SelectedContactType }}
                            <i
                              class="bi bi-x-lg cursor-select"
                              (click)="deselectContactType(SelectedContactType)"
                            ></i>
                          </span>
                        }
                      </div>
                      <ul
                        class="dropdown-menu dropdown-menu-width"
                        [class.show]="contactTypeDropdownOpen"
                        aria-labelledby="contact-type-dropdown"
                        (click)="$event.stopPropagation()"
                      >
                        <li>
                          @if (isBidBillingComplianceContact()) {
                            <button
                              type="button"
                              class="dropdown-item cursor-select"
                              (click)="
                                deselectBidBillingCompliance();
                                $event.stopPropagation()
                              "
                            >
                              Additional Contact
                            </button>
                          }
                        </li>
                        @for (
                          ContactType of ContactTypeOptions;
                          track ContactType
                        ) {
                          <li>
                            @if (
                              !SelectedContactTypeOptions.has(ContactType.label)
                            ) {
                              <button
                                type="button"
                                class="dropdown-item cursor-select"
                                (click)="
                                  selectContactType(ContactType.label);
                                  $event.stopPropagation()
                                "
                              >
                                {{ ContactType.label }}
                              </button>
                            }
                          </li>
                        }
                      </ul>
                    </div>
                    <!--Custom Tag Field Component Above-->
                  </div>
                </div>
              </div>
            }
          </div>

          <div class="row row-padding" formGroupName="Contact">
            @if (UserFormGroup.controls['Contact'].controls['StreetAddress']) {
              <div
                class="row"
                [formGroup]="
                  UserFormGroup.controls['Contact'].controls['StreetAddress']
                "
              >
                <div class="col-md-3">
                  <div class="row">
                    <div class="col">
                      <label class="form-label">Street Address</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <input
                        type="text"
                        class="form-control"
                        formControlName="address1"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="row">
                    <div class="col">
                      <label class="form-label">Street Address 2</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <input
                        type="text"
                        class="form-control"
                        formControlName="address2"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="row">
                    <div class="col">
                      <label class="form-label">City</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <input
                        type="text"
                        class="form-control"
                        formControlName="city"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="row">
                    <div class="col">
                      <label class="form-label">State</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <select class="form-select" formControlName="state">
                        <!--State options goes here.-->
                        @for (
                          SubNationalDivision of SubNationalDivisions;
                          track SubNationalDivision
                        ) {
                          <option [ngValue]="SubNationalDivision.abbreviation">
                            {{ SubNationalDivision.name }}
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="row">
                    <div class="col">
                      <label class="form-label">{{
                        localizationInfo.postalCode.label
                      }}</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <input
                        type="text"
                        class="form-control"
                        formControlName="zip"
                        placeholder="{{ localizationInfo.postalCode.format }}"
                        [inputMask]="
                          country === 'US' ? usZipMask : canadianZipMask
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>

          <div class="row">
            @if (UserFormGroup.controls['Contact'].controls['isBid'].value) {
              <div class="col-3">
                <div class="check-group">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [formControl]="
                      UserFormGroup.controls['Contact'].controls['isPrimaryBid']
                    "
                  />
                  <label class="form-check-label"
                    >Is Primary Bid Contact?</label
                  >
                </div>
              </div>
            }

            @if (
              UserFormGroup.controls['Contact'].controls['isBilling'].value
            ) {
              <div class="col-3">
                <div class="check-group">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [formControl]="
                      UserFormGroup.controls['Contact'].controls[
                        'isPrimaryBilling'
                      ]
                    "
                  />
                  <label class="form-check-label"
                    >Is Primary Billing Contact?</label
                  >
                </div>
              </div>
            }

            @if (
              UserFormGroup.controls['Contact'].controls['isCompliance'].value
            ) {
              <div class="col-3">
                <div class="check-group">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [formControl]="
                      UserFormGroup.controls['Contact'].controls[
                        'isPrimaryCompliance'
                      ]
                    "
                  />
                  <label class="form-check-label"
                    >Is Primary Compliance Contact?</label
                  >
                </div>
              </div>
            }
          </div>

          @if (isClientAdmin()) {
            <div class="row row-padding">
              <div class="col-3">
                <div class="check-group">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [formControl]="UserFormGroup.controls['isSuperUser']"
                  />
                  <label class="form-check-label">Allow Overrides?</label>
                </div>
              </div>

              <div class="col-3">
                <div class="check-group">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [formControl]="UserFormGroup.controls['canWaive']"
                  />
                  <label class="form-check-label"
                    >Can waive compliance findings?</label
                  >
                </div>
              </div>
            </div>
          }

          <div class="action-row mt-4 pt-3 border-top">
            @if (
              User &&
              LoggedInUser.UserAccountRole?.role !==
                'CLIENT_VENDOR_AND_SITES_MANAGER'
            ) {
              @if (!User.deleted) {
                <button class="btn btn-danger" (click)="deleteUser()">
                  Delete user
                </button>
              }
              @if (User.deleted) {
                <button class="btn btn-danger" (click)="undeleteUser()">
                  Undelete user
                </button>
              }
            }
            @if (canResendInvite()) {
              <button
                class="btn btn-outline"
                (click)="resendPasswordEmail('welcome')"
              >
                Resend invite email
              </button>
            }
            @if (User && User.registrationStatus === 'confirmed') {
              <button
                class="btn btn-outline"
                (click)="resendPasswordEmail('reset')"
              >
                Send password reset
              </button>
            }
            <span class="ms-auto"></span>
            <button class="btn btn-ghost" (click)="cancel()">Cancel</button>
            <button class="btn btn-primary" (click)="saveUser()">
              Save user
            </button>
          </div>
        </div>
      </app-display-card>
    </div>
  </div>
</form>
